export default "__VITE_ASSET__BUu_QH3M__"